// extracted by mini-css-extract-plugin
module.exports = {"footerDiv":"Footer_footerDiv__2SduM","mainDiv":"Footer_mainDiv__xEYi1","footerLink":"Footer_footerLink__BRmyi"};